export default "__VITE_ASSET__CFMOZ8bO__"